import { render, staticRenderFns } from "./Garden.vue?vue&type=template&id=651dc1e7&scoped=true&"
import script from "./Garden.vue?vue&type=script&lang=js&"
export * from "./Garden.vue?vue&type=script&lang=js&"
import style0 from "./Garden.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Garden.vue?vue&type=style&index=1&id=651dc1e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651dc1e7",
  null
  
)

export default component.exports